import _slicedToArray from "/var/www/aktywnirazem_frontend_test/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/var/www/aktywnirazem_frontend_test/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/aktywnirazem_frontend_test/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LeafletProvider, createContainerComponent, createControlHook, createElementHook, useLeafletContext } from '@react-leaflet/core';
import { Control } from 'leaflet';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export var useLayersControlElement = createElementHook(function createLayersControl(_ref, ctx) {
  var _c = _ref.children,
      options = _objectWithoutProperties(_ref, _excluded);

  var instance = new Control.Layers(undefined, undefined, options);
  return {
    instance: instance,
    context: _objectSpread(_objectSpread({}, ctx), {}, {
      layersControl: instance
    })
  };
}, function updateLayersControl(control, props, prevProps) {
  if (props.collapsed !== prevProps.collapsed) {
    if (props.collapsed === true) {
      control.collapse();
    } else {
      control.expand();
    }
  }
});
export var useLayersControl = createControlHook(useLayersControlElement); // @ts-ignore

export var LayersControl = createContainerComponent(useLayersControl);
export function createControlledLayer(addLayerToControl) {
  return function ControlledLayer(props) {
    var parentContext = useLeafletContext();
    var propsRef = useRef(props);

    var _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        layer = _useState2[0],
        setLayer = _useState2[1];

    var layersControl = parentContext.layersControl,
        map = parentContext.map;
    var addLayer = useCallback(function (layerToAdd) {
      if (layersControl != null) {
        if (propsRef.current.checked) {
          map.addLayer(layerToAdd);
        }

        addLayerToControl(layersControl, layerToAdd, propsRef.current.name);
        setLayer(layerToAdd);
      }
    }, [layersControl, map]);
    var removeLayer = useCallback(function (layerToRemove) {
      layersControl == null ? void 0 : layersControl.removeLayer(layerToRemove);
      setLayer(null);
    }, [layersControl]);
    var context = useMemo(function () {
      return _objectSpread(_objectSpread({}, parentContext), {}, {
        layerContainer: {
          addLayer: addLayer,
          removeLayer: removeLayer
        }
      });
    }, [parentContext, addLayer, removeLayer]);
    useEffect(function () {
      if (layer !== null && propsRef.current !== props) {
        if (props.checked === true && (propsRef.current.checked == null || propsRef.current.checked === false)) {
          map.addLayer(layer);
        } else if (propsRef.current.checked === true && (props.checked == null || props.checked === false)) {
          map.removeLayer(layer);
        }

        propsRef.current = props;
      }
    });
    return props.children ? /*#__PURE__*/React.createElement(LeafletProvider, {
      value: context
    }, props.children) : null;
  };
}
LayersControl.BaseLayer = createControlledLayer(function addBaseLayer(layersControl, layer, name) {
  layersControl.addBaseLayer(layer, name);
});
LayersControl.Overlay = createControlledLayer(function addOverlay(layersControl, layer, name) {
  layersControl.addOverlay(layer, name);
});